import { useLayoutEffect, useMemo, useRef, useState } from 'react'
import SafeImage from '../SafeImage'
import './index.scss'

/**
 * options: [{ vehicleType: 30, label: "Xe máy", value: 30, icon, iconUrl }]
 * value: vehicleType đang chọn (controlled) - optional
 * defaultValue: vehicleType mặc định (uncontrolled) - optional
 * onChange: (vehicleType, option) => void
 */
export default function VehicleTypeSelected({ options = [], value, defaultValue, onChange, className = '' }) {
  const normalized = useMemo(() => {
    return (options || []).map((o) => ({
      ...o,
      key: o.value ?? o.vehicleType, // dùng value nếu có, fallback vehicleType
      label: o.label ?? o.lable ?? '' // hỗ trợ typo lable
    }))
  }, [options])

  const isControlled = value !== undefined

  const [inner, setInner] = useState(() => {
    const dv = defaultValue ?? normalized?.[0]?.vehicleType
    return dv
  })

  const selected = isControlled ? value : inner

  // activeIndex dựa trên vehicleType (ưu tiên), fallback key
  const activeIndex = useMemo(() => {
    const idx = normalized.findIndex((o) => (o.vehicleType ?? o.key) === selected)
    return Math.max(0, idx === -1 ? 0 : idx)
  }, [normalized, selected])

  const containerRef = useRef(null)
  const tabRefs = useRef([])
  const [indicator, setIndicator] = useState({ left: 0, width: 0 })

  useLayoutEffect(() => {
    const wrap = containerRef.current
    const el = tabRefs.current[activeIndex]
    if (!wrap || !el) return

    const update = () => {
      setIndicator({ left: el.offsetLeft, width: el.offsetWidth })
    }

    update()
    window.addEventListener('resize', update)
    return () => window.removeEventListener('resize', update)
  }, [activeIndex, normalized.length])

  const handleClick = (opt) => {
    const next = opt.vehicleType ?? opt.key
    if (!isControlled) setInner(next)
    onChange?.(next, opt)
  }

  if (!normalized.length) return null

  return (
    <div className={`VehicleTypeSelected ${className}`} ref={containerRef}>
      <div
        className="VehicleTypeSelected__indicator"
        style={{ left: `${indicator.left}px`, width: `${indicator.width - 0.5}px` }}
      />

      {normalized.map((opt, idx) => {
        const active = (opt.vehicleType ?? opt.key) === selected

        return (
          <button
            key={opt.key}
            ref={(node) => (tabRefs.current[idx] = node)}
            type="button"
            className={`VehicleTypeSelected__item ${active ? 'is-active' : ''}`}
            onClick={() => handleClick(opt)}>
            {(opt.IconComponent || opt.icon || opt.iconUrl) && (
              <span className="VehicleTypeSelected__iconWrap">
                {opt.IconComponent ? (
                  <opt.IconComponent className="VehicleTypeSelected__iconImg" />
                ) : opt.icon ? (
                  opt.icon
                ) : (
                  <SafeImage className="VehicleTypeSelected__iconImg" src={opt.iconUrl} />
                )}
              </span>
            )}

            <span className="VehicleTypeSelected__label" title={opt.label}>
              {opt.label}
            </span>
          </button>
        )
      })}
    </div>
  )
}
